export default __webpack_public_path__ + "static/media/company-inactive.f59a95f0.png";